import type { ComponentProps } from "react";
import { css, cva } from "@stubhub/broadway-foundation/css";
import type { Button } from "@stubhub/broadway-web";

// isolation contains this card's own z-index:1 header layer (MobileBannerCardGlassBackground) so it can't out-stack unrelated fixed-position overlays elsewhere on the page (e.g. Ensemble's NavSheet, which has no z-index of its own to compare against).
export const mobileBannerCardWrapper = css({
  display: "flex",
  paddingBlock: "primitives.100",
  paddingInline: "primitives.150",
  justifyContent: "center",
  isolation: "isolate",
});

export const mobileBannerCardWrapperWhite = css({
  display: "flex",
  paddingBlock: "primitives.100",
  paddingInline: "primitives.150",
  justifyContent: "center",
  backgroundColor: "bg.surface",
  isolation: "isolate",
});

export const titleContainer = css({
  display: "flex",
  justifyContent: "center",
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "primitives.0",
  flexDirection: "column",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
});

export const mobileCredibilityBadgeInHero = css({
  width: "[fit-content]",
  height: "[20px]",
  minHeight: "[20px]",
  paddingBlock: "primitives.25",
  paddingInlineStart: "primitives.25",
  paddingInlineEnd: "[10px]",
  columnGap: "primitives.75",
  rowGap: "primitives.75",
  borderStartRadius: "element.extraSmall",
  borderEndRadius: "element.extraSmall",
  backdropFilter: "[blur(6px)]",
});

export const buttonsContainer = css({
  display: "flex",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  alignItems: "center",
  justifySelf: "flex-end",
});

export const imageStyle = css({
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  borderEndEndRadius: "element.default",
});

export const mlbPartnerBackgroundRecipe = cva({
  base: {
    borderStartStartRadius: "element.default",
    borderStartEndRadius: "element.default",
    borderEndStartRadius: "element.default",
    borderEndEndRadius: "element.default",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "var(--mobile-banner-partner-logo-background-height)",
    width: "var(--mobile-banner-partner-logo-background-width)",
  },
  variants: {
    partnerColor: {
      custom: {
        backgroundColor: "var(--mobile-banner-partner-logo-background-color)",
      },
      default: {},
    },
  },
  defaultVariants: {
    partnerColor: "default",
  },
});

export const moreIconStyle = css({
  // @ts-expect-error -- TODO: Add `inherit` as a valid color property
  color: "inherit",
  width: "primitives.250",
  height: "primitives.250",
  position: "absolute",
  insetBlockStart: "primitives.150",
  insetInlineEnd: "primitives.150",
});

export const buttonClassesMoreInfo: NonNullable<ComponentProps<typeof Button>["classes"]> = {
  root: moreIconStyle,
};

export const drawerButtonsContainer = css({
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  paddingBlockEnd: "primitives.200",
});

export const drawerButton = css({
  justifyContent: "flex-start",
  textAlign: "start",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
});

export const inlineTitleAndButtonsContainer = css({
  display: "flex",
  flexDirection: "column",
});

export const fullWidth = css({
  width: "full",
});

export const tourSubtitleStyle = css({
  color: "text.onFill",
  textStyle: "body.small",
  marginBlockStart: "[-6px]",
});

export const mlbPlayoffsSubtitle = css({
  color: "text.onDark",
  textStyle: "body.medium",
});
